<div class="text-center" style="height: 91vh;color: #F15D22;">
    <h1 class="p-5">You are not authorized to go here!</h1>
</div>